import React from 'react';
import {
    Grid, Typography, Paper, Box, Table, TableBody, TableContainer, TableHead,
    Button,
    Divider,
} from '@mui/material';
import styles from '../../../styles.module.css'
import { Breadcrumb, ComponentToPrintQuotationWrapper, DateConversion, StyledTableCell, StyledTableRow } from '../../reusableComponent/Reusables';
import { useLocation } from 'react-router-dom';
import GRNPrint from './GRNPrint';
const rows = [
    {
        cyl_status: "Active",
        history_dt: "2022-01-10",
        resulting_location: "Plant A",
    },
    {
        cyl_status: "Maintenance",
        history_dt: "2021-11-05",
        resulting_location: "Workshop B",
    },
    {
        cyl_status: "Inactive",
        history_dt: "2023-06-18",
        resulting_location: "Warehouse C",
    },
    {
        cyl_status: "Lost",
        history_dt: "2020-09-25",
        resulting_location: "Unknown",
    },
    {
        cyl_status: "In Transit",
        history_dt: "2023-03-12",
        resulting_location: "Distribution Hub D",
    },
    {
        cyl_status: "Active",
        history_dt: "2022-07-30",
        resulting_location: "Plant B",
    },
    {
        cyl_status: "Scrapped",
        history_dt: "2021-04-15",
        resulting_location: "Recycling Center E",
    }
];

const GRNDetails = (props) => {

    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const detailInfo = editInfo && editInfo;


    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                <Breadcrumb
                    routeSegments={[
                        { name: 'GRN Details' },
                    ]}
                />
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.add_form_title}`}>
                                    {detailInfo ? 'GRN' : 'Create'}  Details
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box>
                    <Grid container spacing={1} sx={{ mb: 0, p: 2 }}>
                        <Grid item md={8}>
                            <Grid container spacing={1} sx={{ mt: 0 }}>
                                <Grid item md={3.6}>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>RFQ No</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Invoice No</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Invoice Date</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Challan No</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Challan Date</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>LR No</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Transporter</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Vehicle No</Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>Driver</Typography>
                                </Grid>
                                <Grid item md={0.6}>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>
                                    <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold' }}>: </Typography>

                                </Grid>
                                <Grid item md={7.8}>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.rfq_no}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.invoice_no}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {DateConversion(detailInfo.ht_due_dt)}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.challan_no}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {DateConversion(detailInfo.manufacturer_dt)}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.lr_no}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.transporter}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.vehicle_no}</Typography>
                                    <Typography className={`${styles.cts_lable}`}> {detailInfo.driver_name}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={4} sx={{ borderLeft: '1px solid #c0c0c0' }} >
                            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'start' }}>
                                <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold', color: '#2d94ed', cursor: 'pointer' }}>Edit GRN Details</Typography>
                                {/* <Typography className={`${styles.cts_lable}`} sx={{ fontWeight: 'bold', color: '#2d94ed', cursor: 'pointer' }}>Print This GRN</Typography> */}
                                <ComponentToPrintQuotationWrapper printDetails={detailInfo} PrintComponent={GRNPrint}> </ComponentToPrintQuotationWrapper>
                                {/* <Button variant="outlined" sx={{ fontSize: '11px', color: '#000000', padding: '4px', border: '1px solid #000000' }}>Add Alert Note To Sylinder</Button> */}
                            </Box>
                        </Grid>
                        <Grid item md={12}>
                            <Typography variant="h" sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                paddingTop: '20px',
                                paddingBottom: '20px',
                                // fontWeight: 'bold',
                                color: '#287cb3',
                                position: 'relative',
                                '&::before': {
                                    content: '""',
                                    flex: 0.1,
                                    borderBottom: '1px solid #e0e0e0',
                                    marginRight: '20px'
                                },
                                '&::after': {
                                    content: '""',
                                    flex: 1,
                                    borderBottom: '1px solid #e0e0e0',
                                    marginLeft: '20px'
                                }
                            }}>
                                Product Details
                            </Typography>
                        </Grid>
                        <Grid item md={12}>
                            <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                                <Table size="small" stickyHeader>
                                <TableHead >
                                            <StyledTableRow >
                                                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2} width="8%">Sr No</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}  rowSpan={2} width="25%">PO No & Date</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2} width="15%">Item Code</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}  width="25%">Item Description</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}  width="15%">Dept / Unit</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}>UOM</StyledTableCell>
                                                <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} colSpan={6}>Quantity</StyledTableCell>
                                                {/* <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Challan Qty</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Received Qty</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Short Qty</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Excess Qty</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Rejected Qty</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Accepted Qty</StyledTableCell> */}
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}>Unit Rate</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}>Discount</StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }} rowSpan={2}>Amount</StyledTableCell>
                                            </StyledTableRow>
                                            <StyledTableRow >
                                            <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Challan </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Received </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Short </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Excess </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Rejected </StyledTableCell>
                                                <StyledTableCell align="right" className={`${styles.table_head}`} sx={{ backgroundColor: '#ededed', fontSize: '12px' }}>Accepted</StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                    <TableBody>
                                        {Array.isArray(rows) && rows.map((row, index) => (
                                            <StyledTableRow
                                                key={row.name}
                                                sx={{ 'td, th': { border: '1px solid #c0c0c0' } }} >
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.history_dt}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.cyl_status}</StyledTableCell>
                                                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.resulting_location}</StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </>
    );
}

export default GRNDetails;